/**
 * Generador de contraseñas seguras.
 * Produce contraseñas que cumplen requisitos mínimos:
 * - Mínimo 12 caracteres
 * - Al menos 1 mayúscula, 1 minúscula, 1 número, 1 símbolo
 */

const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ';   // sin I, O (confusos)
const LOWER = 'abcdefghjkmnpqrstuvwxyz';     // sin i, l, o
const DIGITS = '23456789';                    // sin 0, 1 (confusos)
const SYMBOLS = '!@#$%&*+-=?';

const ALL = UPPER + LOWER + DIGITS + SYMBOLS;

/**
 * Genera una contraseña segura aleatoria.
 * @param {number} length - Longitud (mínimo 12)
 * @returns {string}
 */
export function generatePassword(length = 14) {
  const len = Math.max(length, 12);
  const arr = new Uint32Array(len + 4);
  crypto.getRandomValues(arr);

  // Garantizar al menos uno de cada tipo
  const required = [
    UPPER[arr[0] % UPPER.length],
    LOWER[arr[1] % LOWER.length],
    DIGITS[arr[2] % DIGITS.length],
    SYMBOLS[arr[3] % SYMBOLS.length],
  ];

  // Rellenar el resto con caracteres aleatorios
  const rest = Array.from({ length: len - 4 }, (_, i) =>
    ALL[arr[i + 4] % ALL.length]
  );

  // Mezclar para que los requeridos no estén siempre al inicio
  const combined = [...required, ...rest];
  const shuffleArr = new Uint32Array(combined.length);
  crypto.getRandomValues(shuffleArr);
  combined.sort((_, __, i = shuffleArr[combined.indexOf(_)]) => i - shuffleArr[combined.indexOf(__)] || 0);

  // Mezcla simple Fisher-Yates
  for (let i = combined.length - 1; i > 0; i--) {
    const j = shuffleArr[i] % (i + 1);
    [combined[i], combined[j]] = [combined[j], combined[i]];
  }

  return combined.join('');
}

/**
 * Evalúa la fortaleza de una contraseña.
 * @returns {{ score: number, label: string, color: string }}
 */
export function evaluateStrength(password) {
  if (!password) return { score: 0, label: '', color: '#e5e7eb' };

  let score = 0;
  if (password.length >= 8)  score++;
  if (password.length >= 12) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[a-z]/.test(password)) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[^A-Za-z0-9]/.test(password)) score++;

  if (score <= 2) return { score, label: 'Débil',    color: '#ef4444' };
  if (score <= 4) return { score, label: 'Regular',  color: '#f59e0b' };
  if (score === 5) return { score, label: 'Buena',   color: '#3b82f6' };
  return              { score, label: 'Fuerte',   color: '#10b981' };
}
